import React from 'react';
import ReactGA from 'react-ga4';

const Content = () => {
  return (
    <>
      <div className="popup-content-title">
        <h3>South Melbourne – Sewer Upgrade</h3>
      </div>
      <div className="popup-content-source">
        <p>
          <span className="bold">
            We’re planning to increase the capacity of the local sewerage
            network in the South Melbourne and Southbank areas, to future proof
            against extreme weather events from climate change.
          </span>
        </p>
        <p>Due to the size of the project we've split it into four stages:</p>
        <p>
          <span className="bold">Stage 1</span>&nbsp;was completed in early 2024
          and involved the construction of a new sewer and manholes along Stead
          Street and Palmerston Crescent (both sides of Kings Way).
        </p>
        <p>
          <span className="bold">Stage 2</span> Investigations are now underway
          with construction starting in mid 2026, we have appointed our delivery
          partner Beca Fulton Hogan Interflow Joint Venture (BFHI) to complete
          these works. New sewer mains will be installed from Stage 1 through to
          City Road and we’re also intending to build a pumping station in
          Market Street.
        </p>
        <p>
          <span className="bold">Stages 3 and 4</span> include relining the
          sewer beneath Kings Way and Wells Street. This will need significant
          future investigations and is expected to be delivered later this
          decade.
        </p>
        <p>
          For more information click{' '}
          <a
            href="https://southeastwater.com.au/southmelbourne"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: `Map – Major Projects (orange)`,
                action: '<a href> link',
                label: 'MORE INFO: South Melbourne – Sewer Upgrade',
              });
            }}
          >
            here
          </a>{' '}
          or contact the project team at{' '}
          <a href="tel:1800728256">1800 728 256</a> |{' '}
          <a
            href="mailto:southmelbourne@sew.com.au"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: `Map - Major Projects (orange)`,
                action: 'Email link',
                label:
                  'MAIL TO: engagement@sew.com.au: South Melbourne – Sewer Upgrade',
              });
            }}
          >
            southmelbourne@sew.com.au
          </a>
        </p>
      </div>
    </>
  );
};

export default Content;
